import {defineStore} from "pinia";
import ClientDetailsQuestion from "../components/questions/ClientDetailsQuestion.vue";
import SetSessionCategoryQuestion from "../components/questions/SetSessionCategoryQuestion.vue";
import SetLocationQuestion from "../components/questions/SetLocationQuestion.vue";
import TherapyRequiredQuestion from "../components/questions/TherapyRequiredQuestion.vue";
import CancellationPolicyQuestion from "../components/questions/CancellationPolicyQuestion.vue";
import PrivacyPolicyQuestion from "../components/questions/PrivacyPolicyQuestion.vue";
import BookAppointmentQuestion from "../components/questions/BookAppointmentQuestion.vue";

export const QuestionsStore = defineStore('questions', {
    state: () => ({
        questions: {
            1: {
                name: "clientDetails",
                component: ClientDetailsQuestion,
                validateEmail(email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                },
                validate(formData) {
                    let errors = [];

                    if (!formData.bookingType) {
                        errors.push("Please set the who the booking is for")
                    }

                    formData.questions.forEach((question) => {
                        if(!question.value && question.required) {
                            if(question.error) {
                                errors.push(question.error);
                            }
                        } else if(question.type === 'email' && question.required) {
                            var isValid = this.validateEmail(question.value);

                            if(!isValid) {
                                errors.push('Please enter a valid Email Address');
                            }
                        }
                    });

                    return errors;
                },
            },
            2: {
                name: "sessionCategory",
                component: SetSessionCategoryQuestion,
                validate(formData) {
                    const errors = [];

                    if (!formData.sessionCategory) {
                        errors.push("Please select a session category before continuing");
                    }

                    return errors;
                },
            },
            3: {
                name: "location",
                component: SetLocationQuestion,
                validate(formData) {
                    const errors = [];

                    if (!formData.location) {
                        errors.push("Please select a location before continuing")
                    }

                    return errors;
                },
            },
            4: {
                name: "therapyRequired",
                component: TherapyRequiredQuestion,
                validate (formData) {
                    const errors = [];

                    if (!formData.therapy) {
                        errors.push("Please select a therapy before continuing");
                        return errors;
                    }

                    if (formData.therapy.name === 'Other' && !formData.therapyOtherDetails) {
                        errors.push("Please enter the details of the therapy you require")
                    }

                    return errors;
                }
            },
            5: {
                name: "cancellationPolicy",
                component: CancellationPolicyQuestion,
                validate (formData) {
                    const errors = [];

                    if (!formData.cancellationPolicy) {
                        errors.push("Please accept the cancellation policy before proceeding")
                    }

                    return errors;
                }
            },
            6: {
                name: "privacyPolicy",
                component: PrivacyPolicyQuestion,
                validate (formData) {
                    const errors = [];

                    if (!formData.privacyPolicy) {
                        errors.push("Please accept the privacy policy before proceeding");
                    }

                    return errors;
                }
            },
            7: {
                name: "bookingCalendar",
                component: BookAppointmentQuestion,
                validate (formData) {
                    const errors = [];

                    if (formData.date === null) {
                        errors.push("Please select a date before proceeding");
                    }

                    if (formData.time === null) {
                        errors.push("Please select a time before proceeding")
                    }

                    return errors;
                }
            }
        }
    }),
});